import React, { useState, useEffect, useRef } from "react";
import { FaChevronLeft } from "react-icons/fa";
import { HiDotsHorizontal } from "react-icons/hi";
import { postFeedback } from "../api/post/postFeedback";
import { saveAudioForOffline } from "../utils/indexedDB"; // Ensure this function is updated
import { useParams } from "react-router-dom";

// ---
// SendFeedbackModal Component (no changes needed here)
// ---
const SendFeedbackModal = ({ onClose }) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [feedbackType, setFeedbackType] = useState("error"); // Default to 'error'
    const [status, setStatus] = useState(""); // To show success or error messages
    const modalRef = useRef(null); // Ref for the modal content

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Жіберу..."); // Sending...

        const result = await postFeedback({
            name,
            email,
            message,
            type: feedbackType,
        });

        if (result.success) {
            setStatus("Пікіріңіз жіберілді!"); // Feedback sent!
            setTimeout(() => {
                onClose();
            }, 1500);
        } else {
            setStatus(`Қате: ${result.error}`); // Error: [error message]
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
            <div ref={modalRef} className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md relative">
                <h2 className="text-xl font-bold mb-4 text-center">Шағым жіберу</h2> {/* Send Complaint */}
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                            Атыңыз:
                        </label> {/* Your Name: */}
                        <input
                            type="text"
                            id="name"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                            Электрондық пошта:
                        </label> {/* Email: */}
                        <input
                            type="email"
                            id="email"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="feedbackType" className="block text-sm font-medium text-gray-700">
                            Шағым түрі:
                        </label> {/* Complaint Type: */}
                        <select
                            id="feedbackType"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            value={feedbackType}
                            onChange={(e) => setFeedbackType(e.target.value)}
                        >
                            <option value="error">Қате</option> {/* Error */}
                            <option value="bug">Бағдарламалық қате</option> {/* Bug */}
                            <option value="message">Ұсыныс/хабарлама</option> {/* Suggestion/message */}
                        </select>
                    </div>
                    <div>
                        <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                            Хабарлама:
                        </label> {/* Message: */}
                        <textarea
                            id="message"
                            rows="4"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            required
                        ></textarea>
                    </div>
                    <div className="text-center">
                        <button
                            type="submit"
                            className="px-6 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors"
                        >
                            Жіберу
                        </button> {/* Submit */}
                    </div>
                    {status && <p className="text-center mt-2">{status}</p>}
                </form>
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-lg"
                >
                    Жабу {/* Close */}
                </button>
            </div>
        </div>
    );
};

const AboutBookModal = ({ onClose, bookDescription, bookAuthor }) => {
    const modalRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
            <div ref={modalRef} className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md relative">
                <h2 className="text-xl font-bold mb-4 text-center">Кітап туралы</h2> {/* About Book */}
                <p className="text-gray-700">
                    **Автор:** {bookAuthor}
                    <br />
                    **Сипаттама:** {bookDescription}
                </p>
                <div className="text-center mt-6">
                    <button onClick={onClose} className="px-6 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors">
                        Жабу {/* Close */}
                    </button>
                </div>
            </div>
        </div>
    );
};
const DetailHeader = ({
    title,
    onBack,
    textColor = "text-white",
    bgColor = "bg-transparent",
    bookDescription,
    bookAuthor,
    currentAudioLink,
    currentAudioName,
    bookId
}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [showSendFeedbackModal, setShowSendFeedbackModal] = useState(false);
    const [showAboutBookModal, setShowAboutBookModal] = useState(false);
    const [saveStatus, setSaveStatus] = useState(''); // New state for save status message
    const [downloadProgress, setDownloadProgress] = useState(0); // New state for download progress
    const dropdownRef = useRef(null);
    const dotsButtonRef = useRef(null);

    // Effect to close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                dotsButtonRef.current &&
                !dotsButtonRef.current.contains(event.target)
            ) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => setShowDropdown(!showDropdown);

    const handleAboutBookClick = () => {
        setShowDropdown(false);
        setShowAboutBookModal(true);
    };

    const handleSendFeedbackClick = () => {
        setShowDropdown(false);
        setShowSendFeedbackModal(true);
    };

    const handleSaveAudioClick = async () => {
        setShowDropdown(false);
        console.log(currentAudioLink, currentAudioName, bookId); // Debugging log to check values
        if (!currentAudioLink || !currentAudioName || !bookId) {
            setSaveStatus("Аудионы сақтау үшін ақпарат жеткіліксіз."); // Not enough info to save audio.
            setDownloadProgress(0); // Reset progress
            setTimeout(() => setSaveStatus(''), 3000);
            return;
        }

        setSaveStatus("Сақталуда..."); // Saving...
        setDownloadProgress(0); // Start progress at 0

        // Pass a callback function to update progress
        const result = await saveAudioForOffline(currentAudioLink, currentAudioName, bookId, (progress) => {
            setDownloadProgress(progress);
        });

        if (result.success) {
            setSaveStatus(result.message); // e.g., "Аудио офлайн режимде сақталды!"
            setDownloadProgress(100); // Set to 100% on success
        } else {
            setSaveStatus(`Сақтауда қате: ${result.error} `); // Error saving: [error message]
            setDownloadProgress(0); // Reset progress on error
        }
        // Clear status and progress after a delay
        setTimeout(() => {
            setSaveStatus('');
            setDownloadProgress(0);
        }, 3000);
    };

    return (
        <>
            <div className={`flex justify-between w-full items-center px-5 py-4 ${bgColor} relative`} style={{ filter: "brightness(0.9)" }}>
                <button onClick={onBack}>
                    <FaChevronLeft className={`text - lg cursor - pointer ${textColor} `} />
                </button>

                <h1 className={`text-base font-medium truncate flex-1 px-2 w-62 h-12 flex items-center justify-center ${textColor} `}>
                    {title}
                </h1>

                <div className="relative">
                    <HiDotsHorizontal
                        onClick={toggleDropdown}
                        className={`text - lg cursor - pointer ${textColor} `}
                        ref={dotsButtonRef}
                    />

                    {showDropdown && (
                        <div
                            ref={dropdownRef}
                            className="absolute right-0 mt-2 w-44 bg-white text-black rounded-xl shadow-xl z-50 overflow-hidden animate-fade-in backdrop-blur-md border border-gray-200"
                            style={{ transform: "scaleX(-1)" }} // Keeps the dropdown content from mirroring
                        >
                            {/* Reset transform for content */}
                            <div style={{ transform: "scaleX(-1)" }}>
                                <button
                                    className="w-full text-left px-5 py-3 hover:bg-gray-100 transition-all duration-200 font-medium"
                                    onClick={handleAboutBookClick}
                                >
                                    Кітап туралы {/* About Book */}
                                </button>
                                <button
                                    className="w-full text-left px-5 py-3 hover:bg-gray-100 transition-all duration-200 font-medium"
                                    onClick={handleSaveAudioClick}
                                >
                                    Аудионы сақтау {/* Save Audio */}
                                </button>
                                <button
                                    className="w-full text-left px-5 py-3 hover:bg-gray-100 transition-all duration-200 font-medium text-red-600"
                                    onClick={handleSendFeedbackClick}
                                >
                                    Шағым жіберу {/* Send Complaint */}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Fixed Overlay for Save Status and Progress Bar */}
            {(saveStatus || downloadProgress > 0) && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
                    <div className="bg-white p-6 rounded-lg shadow-xl text-center flex flex-col items-center max-w-xs w-full">
                        <p className="text-lg font-semibold mb-3">
                            {saveStatus || (downloadProgress > 0 && downloadProgress < 100 ? `Жүктелуде: ${downloadProgress.toFixed(0)}% ` : '')}
                        </p>
                        {downloadProgress > 0 && downloadProgress < 100 && (
                            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                                <div
                                    className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-out"
                                    style={{ width: `${downloadProgress}% ` }}
                                ></div>
                            </div>
                        )}
                        {downloadProgress === 100 && saveStatus && ( // Show success message when 100%
                            <p className="text-green-600 mt-2">{saveStatus}</p>
                        )}
                        {downloadProgress === 0 && saveStatus && saveStatus.includes("Қате") && ( // Show error message
                            <p className="text-red-600 mt-2">{saveStatus}</p>
                        )}
                    </div>
                </div>
            )}


            {showSendFeedbackModal && <SendFeedbackModal onClose={() => setShowSendFeedbackModal(false)} />}
            {showAboutBookModal && (
                <AboutBookModal
                    onClose={() => setShowAboutBookModal(false)}
                    bookDescription={bookDescription}
                    bookAuthor={bookAuthor}
                />
            )}
        </>
    );
};

export default DetailHeader;